import KpiCard from "../components/KpiCard";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { useEffect, useState } from "react";
import api from "../api";

const chartData = [
  { name: "Jan", fuel: 1200, expense: 820 },
  { name: "Feb", fuel: 980, expense: 700 },
  { name: "Mar", fuel: 1150, expense: 950 },
  { name: "Apr", fuel: 1400, expense: 1100 },
  { name: "May", fuel: 1240, expense: 1020 },
];

function DashboardPage() {
  const [metrics, setMetrics] = useState({ total: "—", active: "—", maintenance: "—", expiring: "—" });

  useEffect(() => {
    Promise.all([api.get("/vehicles"), api.get("/challans")])
      .then(([vehiclesResponse, challansResponse]) => {
        const vehicles = vehiclesResponse.data.data || [];
        const soon = new Date(); soon.setDate(soon.getDate() + 30);
        const expiring = vehicles.filter((vehicle) => [vehicle.insuranceExpiry, vehicle.fitnessExpiry, vehicle.permitExpiry].some((date) => date && new Date(date) <= soon)).length;
        setMetrics({ total: vehicles.length, active: vehicles.filter((vehicle) => vehicle.status === "active").length, maintenance: vehicles.filter((vehicle) => vehicle.status === "under_maintenance").length, expiring: expiring + (challansResponse.data.data || []).filter((challan) => challan.paymentStatus === "unpaid").length });
      })
      .catch(() => {});
  }, []);

  return (
    <div className="dashboard-page">
      <div className="kpi-grid">
        <KpiCard label="Total Vehicles" value={metrics.total} />
        <KpiCard label="Active Vehicles" value={metrics.active} variant="success" />
        <KpiCard label="Under Maintenance" value={metrics.maintenance} variant="warning" />
        <KpiCard label="Attention needed" value={metrics.expiring} variant="danger" />
      </div>

      <section className="dashboard-section">
        <div className="section-card">
          <h2>Fuel & Expense Trends</h2>
          <ResponsiveContainer width="100%" height={320}>
            <BarChart data={chartData}>
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="fuel" fill="#0d6efd" />
              <Bar dataKey="expense" fill="#198754" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </section>
    </div>
  );
}

export default DashboardPage;
